import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKey, Maybe } from "types/generated";

type ResetApiKeyData = {
  apiKeyReset: Maybe<Pick<ApiKey, "id" | "name" | "secret">>;
};

type ResetApiKeyVariables = {
  id: string;
};

export const RESET_API_KEY: TypedDocumentNode<ResetApiKeyData, ResetApiKeyVariables> = gql`
  mutation ResetApiKey($id: ID!) {
    apiKeyReset(id: $id) {
      id
      name
      secret
    }
  }
`;
